import { useCallback, useContext, useMemo } from "react";
import { AppContext } from "../../../Contexts/Contexts";
import AutocompleteField from "./AutocompleteField";
import StandardField from "./StandardField";
import ExtractionTable from "./ExtractionTable";
import Entity from "./Entity";

const checkbox = { options: ["0", "1"] };

const versioningIsActive = (pipeline) => {
  const versioning = pipeline.find(
    (stage) => stage.stageName === "VerValidate"
  );
  return versioning?.isActive;
};

const ExtractionRow = ({ data, index, style }) => {
  // console.log("extraction row");
  const { documentTypes, pipeline, versioning, appSettings } =
    useContext(AppContext);
  const versionOptions = useMemo(
    () =>
      versioning.versions.flatMap((version) =>
        version.showAsDropdownOption ? [version.name] : []
      ),
    [versioning]
  );

  const getFieldWidth = useCallback((fields) => {
    const FIELD_WIDTH = 530;
    if (fields.length === 1) return FIELD_WIDTH / 2 + "px";
    return FIELD_WIDTH / fields.length + "px";
  }, []);

  const getOptions = useCallback(
    (field) => {
      switch (field.name) {
        case "DocumentType":
          return documentTypes;
        case "Version":
          return versionOptions;
        default:
          return field.config.options;
      }
    },
    [documentTypes, versionOptions]
  );

  const Row = (row) => {
    if (row.visibility === "collapsed") return null;
    switch (row.type) {
      case "group":
        return <h1 className="font-18 pad-5">{row.label}</h1>;
      case "subgroup":
        return <h2 className="font-18 pad-5">{row.label}</h2>;
      case "fields":
        const visibleFields = row.fields.filter(
          (field) => field.config.visibility !== "collapsed"
        );
        return (
          <div className="flex">
            {visibleFields.map((field, idx) => {
              if (field.name === "Version") {
                if (
                  !versioningIsActive(pipeline) &&
                  !appSettings.showVersionInExtraction
                )
                  return null;
              }
              switch (field.config.inputType) {
                case "autocomplete":
                  return (
                    <AutocompleteField
                      key={idx}
                      field={field}
                      options={getOptions(field)}
                      onChange={data.onChange}
                      onFocus={data.onFocus}
                      addRef={data.addRef}
                      width={getFieldWidth(visibleFields)}
                    />
                  );
                case "checkbox":
                  return (
                    <AutocompleteField
                      key={idx}
                      field={field}
                      options={checkbox.options}
                      onChange={data.onChange}
                      onFocus={data.onFocus}
                      addRef={data.addRef}
                      width={getFieldWidth(visibleFields)}
                    />
                  );
                default:
                  return (
                    <StandardField
                      key={idx}
                      field={field}
                      onChange={data.onChange}
                      onFocus={data.onFocus}
                      addRef={data.addRef}
                      width={getFieldWidth(visibleFields)}
                    />
                  );
              }
            })}
          </div>
        );
      case "tables":
        return (
          <ExtractionTable
            table={row.tables[0]}
            onFocus={data.onFocus}
            onChange={data.onTableChange}
            onRowUpdate={data.onTableRowUpdate}
          />
        );
      case "entities":
        return <Entity row={row} Row={Row} />;
      default:
        return null;
    }
  };

  return <div style={style}>{Row(data.rows[index])}</div>;
};

export default ExtractionRow;
